<template>
    <EmployeeServiceReports></EmployeeServiceReports>
</template>
<script>
    import EmployeeServiceReports from '@/components/EmployeeServiceReports.vue'
    export default {
        name: 'employee-service-reports',
        components: {
            EmployeeServiceReports
        }
    }
</script>